// extracted by mini-css-extract-plugin
module.exports = {"s1hfctpl":"s1hfctpl"};